<template>
  <b-form-group
    label="7. Indikasi Tercatat Gabungan (Gelondongan)"
    label-for="indikasiGabungan"
  >
    <b-form-select
      v-model="indikasiGabungan"
      disabled
      :options="dataIndikasiGabungan"
    />

    <b-col
      v-if="indikasiGabungan == '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Keterangan"
        label-for="indikasiGabunganKeterangan"
        label-size="lg"
        label-class="pb-0 pt-0"
      >
        <slot />
      </b-form-group>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    indikasiGabungan: { type: String, default: null },
  },
  data() {
    return {
      dataIndikasiGabungan: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '0', text: 'Tidak Tercatat Gabungan' },
        { value: '1', text: 'Terindikasi Gabungan' },
      ],
    }
  },
}
</script>
